/**
 * Submit a Netlify Forms-compatible POST from a React form.
 * Requires matching hidden form blueprints in public/index.html.
 */
export async function submitNetlifyForm(formElement, formName) {
  const formData = new FormData(formElement);
  formData.set('form-name', formName);
  if (!formData.has('bot-field')) {
    formData.set('bot-field', '');
  }

  const response = await fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(formData).toString(),
  });

  if (!response.ok) {
    throw new Error(`Form submission failed (${response.status})`);
  }

  return response;
}
